import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Award, TrendingUp, Users } from 'lucide-react';

const TravelerCard = ({ traveler }) => {
  // Create a beautiful cover gradient based on user ID
  const getGradient = (name) => {
    const colors = [
      'from-blue-500 to-cyan-400',
      'from-purple-500 to-indigo-500',
      'from-rose-400 to-orange-400',
      'from-emerald-400 to-teal-500',
      'from-amber-400 to-orange-500'
    ];
    const index = (name || '').length % colors.length;
    return colors[index];
  };
  
  const gradient = getGradient(traveler.name);
  
  // Use real followers from the backend
  const followers = (traveler.followerCount || 0).toLocaleString();

  return (
    <div className="group flex flex-col items-center rounded-[28px] bg-white shadow-sm hover:shadow-[0_20px_40px_rgb(0,0,0,0.08)] transition-all duration-500 w-full sm:w-[280px] overflow-hidden relative border border-gray-100/80 transform hover:-translate-y-2">
      
      {/* Banner */}
      <div className={`w-full h-24 bg-gradient-to-r ${gradient} relative overflow-hidden`}>
        {/* Subtle shine effect */}
        <div className="absolute inset-0 bg-white/20 -skew-x-12 translate-x-[-150%] group-hover:translate-x-[150%] transition-transform duration-1000 ease-in-out"></div>
      </div>
      
      {/* Avatar Container */}
      <div className="relative -mt-12 mb-3 px-6 w-full flex justify-center">
        <div className="relative">
          <div className="w-24 h-24 rounded-full bg-teal-600 text-white font-black text-4xl flex items-center justify-center border-[4px] border-white shadow-md group-hover:scale-105 transition-transform duration-500 z-10 relative">
            {traveler.name ? traveler.name.charAt(0).toUpperCase() : '?'}
          </div>
          <div className="absolute bottom-0 right-0 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow-sm z-20">
            {traveler.isVerified ? (
              <CheckCircle size={22} className="text-blue-500" fill="currentColor" stroke="white" />
            ) : (
              <div className="w-6 h-6 bg-orange-50 rounded-full flex items-center justify-center border border-orange-100">
                <Award size={14} className="text-orange-500" />
              </div>
            )}
          </div>
        </div>
      </div>
      
      <div className="text-center px-6 w-full mb-6">
        <h4 className="font-extrabold text-gray-900 text-xl mb-1 tracking-tight truncate w-full">{traveler.name}</h4>
        
        <div className="text-sm text-gray-500 mb-5 flex items-center justify-center gap-2 font-medium">
          {traveler.handle ? <span className="truncate max-w-[120px]">@{traveler.handle}</span> : <span>Traveler</span>}
          <span className="text-gray-300">•</span>
          <span className="flex items-center gap-1"><Users size={14} className="text-blue-500"/> {followers} followers</span>
        </div>
        
        <div className="flex justify-center gap-3 w-full">
          <div className="flex-1 bg-gray-50 rounded-2xl py-3 border border-gray-100/80 group-hover:bg-blue-50/50 group-hover:border-blue-100 transition-colors duration-300">
            <div className="text-xl font-black text-gray-900">{traveler.postCount || 0}</div>
            <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">Trips</div>
          </div>
          <div className="flex-1 bg-gray-50 rounded-2xl py-3 border border-gray-100/80 group-hover:bg-amber-50/50 group-hover:border-amber-100 transition-colors duration-300">
            <div className="text-xl font-black text-gray-900">{(traveler.totalCredits || 0).toLocaleString()}</div>
            <div className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-1">RoamPoints</div>
          </div>
        </div>
      </div>
      
      <div className="px-6 pb-6 w-full">
        <button className="w-full py-3.5 rounded-2xl bg-gray-900 text-white font-bold hover:bg-blue-600 hover:shadow-lg hover:shadow-blue-500/25 transition-all duration-300 active:scale-95 flex items-center justify-center gap-2">
          Follow Storyteller
        </button>
      </div>
    </div>
  );
};

export default TravelerCard;
